import { scim } from '@talend/context';

import { ENTITLEMENTS } from '../constants';

const canCreateCAD = (): boolean =>
	scim.me.hasEntitlement(scim.me.getCache(), ENTITLEMENTS.CUSTOM_ATTRIBUTE_CREATE);

const canEditCAD = (): boolean =>
	scim.me.hasEntitlement(scim.me.getCache(), ENTITLEMENTS.CUSTOM_ATTRIBUTE_UPDATE);

const canDeleteCAD = (): boolean =>
	scim.me.hasEntitlement(scim.me.getCache(), ENTITLEMENTS.CUSTOM_ATTRIBUTE_DELETE);

const getPreferredLanguage = (): string => scim.me.getCache().preferredLanguage;

export { canCreateCAD, canEditCAD, canDeleteCAD, getPreferredLanguage };
